import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AddClients.css";

const LIC_ADMIN_URL = "https://licadmin.n-tools.info";

const AddClients = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // সফল রেজিস্ট্রেশনের পর token স্ক্রিন দেখানোর জন্য
  const [result, setResult] = useState(null); // { client_id, enrollment_token, enrollment_expires_at }
  const [copied, setCopied] = useState("");

  const [form, setForm] = useState({
    customer_name: "",
    address: "",
    phone: "",
    mobile: "",
    email: "",
    network_name: "",
    network_location: "",
    notes: "",
    lan_ip: "",
    public_ip: "",
    license_type: "monthly",
    channel_limit: 50,
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.customer_name || !form.network_name) {
      alert("⚠️ Customer Name এবং Network Name অবশ্যই দিতে হবে!");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post("/api/licenses/create", form);

      if (res.data?.status === "success" && res.data?.enrollment_token) {
        setResult({
          client_id: res.data.client_id,
          enrollment_token: res.data.enrollment_token,
          enrollment_expires_at: res.data.enrollment_expires_at,
        });
      } else {
        alert(res.data?.message || "Failed to register client.");
      }
    } catch (err) {
      console.error("Registration Error:", err);
      alert(err.response?.data?.message || "Failed to finalize database transactions.");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text, key) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(key);
      setTimeout(() => setCopied(""), 1800);
    });
  };

  const formatExpiry = (iso) => {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleString();
    } catch {
      return iso;
    }
  };

  // ================= SUCCESS / TOKEN VIEW =================
  if (result) {
    const envSnippet =
      `LIC_ADMIN_URL=${LIC_ADMIN_URL}\n` +
      `ENROLLMENT_TOKEN=${result.enrollment_token}\n` +
      `A2W_SERVER_NAME=${form.customer_name} (${form.network_name})`;

    return (
      <div style={{ padding: "24px", maxWidth: "760px", margin: "0 auto" }}>
        <div style={{ background: "#fff", padding: "28px", borderRadius: "12px", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)", border: "1px solid #e2e8f0" }}>

          <div style={{ textAlign: "center", marginBottom: "24px" }}>
            <div style={{ fontSize: "42px", marginBottom: "8px" }}>✅</div>
            <h2 style={{ margin: 0, fontSize: "22px", color: "#0f172a", fontWeight: "800" }}>Client Registered Successfully</h2>
            <p style={{ margin: "6px 0 0 0", color: "#64748b", fontSize: "14px" }}>
              Client ID: <strong>#{result.client_id}</strong> — {form.customer_name} ({form.network_name})
            </p>
          </div>

          {/* ENROLLMENT TOKEN BOX */}
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "6px", color: "#334155" }}>
              ENROLLMENT TOKEN (একবারই ব্যবহারযোগ্য · মেয়াদ: {formatExpiry(result.enrollment_expires_at)})
            </label>
            <div style={{ display: "flex", gap: "8px" }}>
              <code style={{ flex: 1, background: "#0f172a", color: "#4ade80", padding: "12px 14px", borderRadius: "8px", fontFamily: "monospace", fontSize: "13px", wordBreak: "break-all", lineHeight: 1.5 }}>
                {result.enrollment_token}
              </code>
              <button
                onClick={() => copyToClipboard(result.enrollment_token, "token")}
                style={{ padding: "0 16px", borderRadius: "8px", border: "none", background: copied === "token" ? "#22c55e" : "#2563eb", color: "#fff", fontWeight: "bold", cursor: "pointer", whiteSpace: "nowrap" }}
              >
                {copied === "token" ? "Copied ✓" : "Copy"}
              </button>
            </div>
          </div>

          {/* .ENV SNIPPET */}
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "6px", color: "#334155" }}>
              Client মেশিনের <code>a2w-web/backend/.env</code> এ বসান:
            </label>
            <div style={{ position: "relative" }}>
              <pre style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", padding: "14px", borderRadius: "8px", fontFamily: "monospace", fontSize: "12.5px", color: "#0f172a", margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
{envSnippet}
              </pre>
              <button
                onClick={() => copyToClipboard(envSnippet, "env")}
                style={{ position: "absolute", top: "8px", right: "8px", padding: "6px 12px", borderRadius: "6px", border: "1px solid #cbd5e1", background: copied === "env" ? "#22c55e" : "#fff", color: copied === "env" ? "#fff" : "#334155", fontWeight: "bold", cursor: "pointer", fontSize: "12px" }}
              >
                {copied === "env" ? "Copied ✓" : "Copy .env"}
              </button>
            </div>
          </div>

          {/* NOTE */}
          <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "8px", padding: "12px 14px", marginBottom: "24px", fontSize: "13px", color: "#92400e", lineHeight: 1.6 }}>
            ⚠️ এই token টা এখনই কপি করে client কে দিন। Client প্রথমবার a2w-web চালু করলে এটা দিয়ে অটো enroll হয়ে api key/secret নিয়ে নেবে। একবার enroll হলে token আর কাজ করবে না।
          </div>

          {/* ACTIONS */}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            <button
              onClick={() => { setResult(null); setForm({ ...form, customer_name: "", network_name: "", phone: "", mobile: "", email: "", address: "", network_location: "", notes: "", lan_ip: "", public_ip: "" }); }}
              style={{ padding: "10px 20px", borderRadius: "6px", border: "1px solid #cbd5e1", background: "#fff", cursor: "pointer", fontWeight: "bold" }}
            >
              + Add Another Client
            </button>
            <button
              onClick={() => navigate("/manage-clients")}
              style={{ padding: "10px 24px", borderRadius: "6px", border: "none", background: "#0f172a", color: "#fff", fontWeight: "bold", cursor: "pointer" }}
            >
              Done → Client List
            </button>
          </div>

        </div>
      </div>
    );
  }

  // ================= FORM VIEW =================
  return (
    <div className="add-client-page-container" style={{ padding: "24px", maxWidth: "800px", margin: "0 auto" }}>

      <div className="add-client-header-wrapper" style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "32px" }}>
        <div>
          <h2 style={{ margin: 0, fontSize: "24px", color: "#1e293b", fontWeight: "800" }}>Onboard New Client</h2>
          <p style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>Client রেজিস্টার করলে একটি enrollment token তৈরি হবে, যা দিয়ে client নিজে থেকে enroll হবে।</p>
        </div>
      </div>

      <div className="add-client-form-card" style={{ background: "#fff", padding: "24px", borderRadius: "12px", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)", border: "1px solid #e2e8f0" }}>

        {/* SECTION 1: CLIENT INFO */}
        <div className="form-section">
          <h3 style={{ borderBottom: "1px solid #e2e8f0", paddingBottom: "8px", color: "#0f172a" }}>1. Client Information</h3>
          <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Customer Name *</label>
              <input name="customer_name" value={form.customer_name} placeholder="e.g. Md. Neamol" onChange={handleChange} className="form-control-input" required />
            </div>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Contact Mobile</label>
              <input name="phone" value={form.phone} placeholder="e.g. 017XXXXXXXX" onChange={handleChange} className="form-control-input" />
            </div>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Email Address</label>
              <input name="email" value={form.email} placeholder="client@n-tools.info" onChange={handleChange} className="form-control-input" />
            </div>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Physical Address</label>
              <input name="address" value={form.address} placeholder="Dhaka, Bangladesh" onChange={handleChange} className="form-control-input" />
            </div>
          </div>
        </div>

        {/* SECTION 2: NETWORK */}
        <div className="form-section">
          <h3 style={{ borderBottom: "1px solid #e2e8f0", paddingBottom: "8px", color: "#0f172a" }}>2. Network & ISP Details</h3>
          <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Network/ISP Name *</label>
              <input name="network_name" value={form.network_name} placeholder="e.g. Neamol Network" onChange={handleChange} className="form-control-input" required />
            </div>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Network Location Area</label>
              <input name="network_location" value={form.network_location} placeholder="e.g. Zone 4" onChange={handleChange} className="form-control-input" />
            </div>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>LAN IP (optional)</label>
              <input name="lan_ip" value={form.lan_ip} placeholder="e.g. 192.168.31.10" onChange={handleChange} className="form-control-input" style={{ fontFamily: "monospace" }} />
            </div>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Public IP (optional)</label>
              <input name="public_ip" value={form.public_ip} placeholder="103.X.X.X" onChange={handleChange} className="form-control-input" style={{ fontFamily: "monospace" }} />
            </div>
          </div>
          <p style={{ fontSize: "11px", color: "#94a3b8", margin: "0 0 8px 0" }}>
            নোট: enroll হওয়ার সময় client নিজেই আসল IP/hostname/UUID পাঠাবে — এখানে দেওয়া মান শুধু রেকর্ড রাখার জন্য।
          </p>
        </div>

        {/* SECTION 3: LICENSE POLICY */}
        <div className="form-section">
          <h3 style={{ borderBottom: "1px solid #e2e8f0", paddingBottom: "8px", color: "#0f172a" }}>3. License Policy</h3>
          <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>License Type</label>
              <select name="license_type" value={form.license_type} onChange={handleChange} className="form-control-input" style={{ width: "100%", height: "40px" }}>
                <option value="monthly">Monthly</option>
                <option value="lifetime">Lifetime</option>
                <option value="others">Others</option>
              </select>
              <p style={{ fontSize: "11px", color: "#94a3b8", margin: "4px 0 0 0" }}>
                Lifetime হলে status সরাসরি active, নাহলে trial দিয়ে শুরু হবে। পরে Manage License থেকে renew/extend করা যাবে।
              </p>
            </div>
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Channel Stream Limit</label>
              <input type="number" name="channel_limit" value={form.channel_limit} onChange={handleChange} className="form-control-input" />
            </div>
            <div style={{ gridColumn: "span 2" }}>
              <label style={{ display: "block", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>Internal Notes</label>
              <textarea name="notes" value={form.notes} placeholder="Setup context, contact person, ইত্যাদি..." onChange={handleChange} className="form-control-input" style={{ minHeight: "40px", width: "100%" }} />
            </div>
          </div>
        </div>

        {/* ACTIONS */}
        <div className="form-actions" style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
          <button type="button" onClick={() => navigate("/manage-clients")} style={{ padding: "10px 20px", borderRadius: "6px", border: "1px solid #cbd5e1", background: "#fff", cursor: "pointer", fontWeight: "bold" }}>
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={loading} className="btn-submit-client" style={{ padding: "10px 24px", borderRadius: "6px", border: "none", background: loading ? "#94a3b8" : "#0f172a", color: "#fff", fontWeight: "bold", cursor: loading ? "not-allowed" : "pointer" }}>
            {loading ? "Registering..." : "🎫 Register & Generate Token"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default AddClients;